<template>
    <v-card
            elevation="0"
            :outlined="$vuetify.breakpoint.smAndUp? true:false"
            max-width="730"
            class="pa-8 mb-10 account-seetings"
    >
        <v-card-text class="pb-0">

            <v-row>
                <v-col>
                    <h3>Personal Information</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-0">
                    <v-text-field outlined
                                  v-model="user.name"
                                  :error-messages="nameErrors"
                                  @input="$v.user.name.$touch()"
                                  @blur="$v.user.name.$touch()"
                                  hide-details="auto"
                                  class="btn-edu-height"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-0">
                    <v-text-field outlined
                                  v-model="user.email"
                                  :error-messages="emailErrors"
                                  @input="$v.user.email.$touch()"
                                  @blur="$v.user.email.$touch()"
                                  hide-details="auto"
                                  class="btn-edu-height"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-0">
                    <v-text-field outlined
                                  placeholder="(555) 555-5555"
                                  :value="formattedPhone"
                                  @input="onPhoneInput"
                                  @blur="$v.user.phone_number.$touch()"
                                  :error-messages="phoneNumberErrors"
                                  hide-details="auto"
                                  class="btn-edu-height"
                                  maxlength="14"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="d-flex mt-2">
                <v-col cols="6" md="4" class="pb-0">
                    <v-btn
                            color="primary"
                            height="45"
                            class="btn-edurent"
                            depressed
                            block
                            @click="submit"
                            :loading="isCallingApi"
                    >Save Changes</v-btn>
                </v-col>
            </v-row>

            <v-row class="d-flex mt-6">
                <v-col>
                    <h3>Change Your Password</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" md="4" class="pb-0">
                    <v-btn
                            color="primary"
                            height="45"
                            class="btn-edurent"
                            depressed
                            block
                            outlined
                            @click="showPasswordModal = true"
                    >Change Password</v-btn>
                </v-col>
            </v-row>
            <ChangePasswordModal
                v-model="showPasswordModal"
                :user-id="user.id"
            />

        </v-card-text>
    </v-card>
</template>

<script>
import { cloneDeep, pick } from 'lodash'
import { required, email } from 'vuelidate/lib/validators'
import ChangePasswordModal from "../components/ChangePasswordModal.vue"

export default {
    name: 'AccountSettings',
    components: {
        ChangePasswordModal
    },
    validations: {
        user: {
            name: { required },
            email: { required, email },
            phone_number: { required }
        }
    },
    props: {
        activeUser: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            user: cloneDeep(this.activeUser),
            showPasswordModal: false,
            isCallingApi: false
        }
    },
    watch: {
        activeUser() {
            if (!this.user || !this.user.id) {
                this.user = cloneDeep(this.activeUser)
            }
        }
    },
    computed: {
        nameErrors () {
            const errors = []
            if (!this.$v.user.name.$dirty) return errors
            !this.$v.user.name.required && errors.push('Name is required.')
            return errors
        },
        emailErrors () {
            const errors = []
            if (!this.$v.user.email.$dirty) return errors
            !this.$v.user.email.email && errors.push('Must be valid e-mail')
            !this.$v.user.email.required && errors.push('E-mail is required')
            return errors
        },
        phoneNumberErrors () {
            const errors = [];
            if (!this.$v.user.phone_number.$dirty) return errors
            !this.$v.user.phone_number.required && errors.push('Phone number is required')
            return errors
        },
        formattedPhone() {
            return this.formatPhoneNumber(this.user.phone_number)
        }
    },
    methods: {
        formatPhoneNumber(value) {
            if (!value) return ''
            const numbers = value.replace(/\D/g, '')
            if (numbers.length === 0) return ''
            if (numbers.length <= 3) return `(${numbers}`
            if (numbers.length <= 6) return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`
            return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`
        },
        onPhoneInput(value) {
            const numbers = value.replace(/\D/g, '').slice(0, 10)
            this.user.phone_number = numbers
            this.$v.user.phone_number.$touch()
        },
        submit: async function() {
            this.$v.user.$touch();
            if (this.$v.user.$invalid) {
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'Mandatory field(s) required for changing your personal information is missing',
                    color: 'red'
                });

                return;
            }

            const updatedUser = pick(this.user, ['id', 'name', 'email', 'phone_number'])

            let hasErrors = false;
            this.isCallingApi = true
            await this.$store.dispatch('updateUser', updatedUser).catch(() => {
                hasErrors = true
            })
            this.isCallingApi = false
            if (hasErrors) {
                return
            }

            this.$store.dispatch('getUserByToken')
        }
    },
    beforeMount() {
        this.$store.dispatch('getUserByToken');
    }
}
</script>

<style>
    .rental-form {
        border: 1px solid #D8D8D8;
        border-radius: 1%;
    }
    .price-slider {
        /*border: 1px solid #D8D8D8;*/
    }
    .account-seetings h3 {
        font-size: 26px !important;
        font-weight: 700;
        color: #000;
    }
</style>
